import React, {useEffect, useState} from 'react'
import { Button, Modal } from 'antd'
import {ModalCloseIco} from '../../../modules/CustomIcons'

import './index.scss'
import {deleteTemplate, upsertTemplate} from "../../services/Transfers/Templates";
import {useHistory} from "react-router-dom";
import { useTranslation } from 'react-i18next';

const DeleteTemplateModal: React.FC<any> = (props : any) => {
    const {t} = useTranslation()
    const [templateIds, setTemplateIds] = useState([]);
    const history=useHistory();

    useEffect(() => {

        setTemplateIds(old_data => (props.isUpdate) ? [props.templateIds] : props.templateIds)

    }, [])

    const onClose = () => {
        props.onClose((old_value) => false)
    }

    const updateAfterDelete = () =>{
        history.push({
            state : {}
        })
        onClose();
        setTemplateIds(old_data => [])

        if(props.callBackApi){
            props.callBackApi();
        }
    }

    const deleteSelectedTemplates = () => {
        let templates=templateIds.map(id => ({
            templateId : id
        }))

        const req_data={
            templates : templates
        }

        if(props.isUpdate){

            upsertTemplate(props.templateIds).then(res => {
                updateAfterDelete();
            })

        }else{
            deleteTemplate(req_data).then(res => {
                updateAfterDelete();
            })
        }


    }

    const modalFooter = () => (
        <>
            <div className='flex justify_between align_center'>
                <Button type="button" className="light-button refresh_btn next_modal_cancel_btn btn flex align_center justify_center" onClick={onClose} >{t("home.no")}</Button>
                <Button type="button" className="blue-button next_btn btn flex align_center justify_center"  onClick={deleteSelectedTemplates} >{t("home.yes")}</Button>
            </div>
        </>
    )

  return (
    <>
        {
            <Modal
                title={t("home.deleteTemplate")}
                closeIcon={<ModalCloseIco />}
                centered
                visible={props.visible}
                onCancel={onClose}
                width={300}
                className={` manage_faster_menus delete_template_modal no_footer  ${props?.className}`}
                keyboard={false}
                focusTriggerAfterClose={false}
                footer={modalFooter()}
            >

                <div className={'full flex align_center delete_template_modal_body'}>


                    <p className={'full flex justify_center'} ><strong>{templateIds.length}</strong> {t("notification.deleteTemplateNotif")}</p>
                </div>

            </Modal>
        }
    </>
  )
}

export default DeleteTemplateModal
